import { reactive } from 'vue';
import {
  User,
  PermissionItem,
  AdminBadgeOptions,
  PermissionName,
} from '@oare/types';

export interface State {
  landed: boolean;
  user: null | User;
  permissions: PermissionItem[];
  displayAdminBadge: AdminBadgeOptions;
}

const state: State = reactive({
  landed: false,
  user: null,
  permissions: [],
  displayAdminBadge: {
    error: false,
    comments: false,
  },
});

export default {
  setUser: (user: User) => {
    state.user = user;
  },
  setLanded: (landed: boolean) => {
    state.landed = landed;
  },
  logout: () => {
    state.user = null;
    state.permissions = [];
  },
  setPermissions: (permissions: PermissionItem[]) => {
    state.permissions = permissions;
  },
  setAdminBadge: (status: AdminBadgeOptions) => {
    state.displayAdminBadge = status;
  },
  hasPermission(name: PermissionName) {
    return state.permissions.map(perm => perm.name).includes(name);
  },
  getters: {
    get isAdmin() {
      return state.user ? state.user.isAdmin : false;
    },
    get landed() {
      return state.landed;
    },
    get isAuthenticated() {
      return !!state.user;
    },
    get user() {
      return state.user;
    },
    get displayAdminBadge() {
      return state.displayAdminBadge;
    },
  },
};
